if (!customElements.get("glitch-banner")) {
  class GlitchBanner extends HTMLElement {
    constructor() {
      super();
      this._onMouseEnter = this._onMouseEnter.bind(this);
      this._onMouseLeave = this._onMouseLeave.bind(this);
    }

    connectedCallback() {
      this.imageEl = this.querySelector("[data-banner-image]");
      this.glitchContainer = this.querySelector("[data-glitch-container]");
      this.staticEl = this.querySelector("[data-glitch-static]");
      this.signalAcquired = false;
      this._hoverTimeout = null;

      // Respect reduced motion
      this._motionQuery = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      );
      if (this._motionQuery.matches) {
        this._acquireSignal();
        return;
      }

      // Start in "signal lost" state
      this._setSignalLost();

      // IntersectionObserver: trigger when 40% visible
      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.signalAcquired) {
              // Keep glitch running for 1.8s then acquire signal
              this._acquireTimeout = setTimeout(() => {
                this._acquireSignal();
              }, 1800);
              this._observer.unobserve(this);
            }
          });
        },
        { threshold: 0.4 },
      );
      this._observer.observe(this);

      // Hover glitch
      this.addEventListener("mouseenter", this._onMouseEnter);
      this.addEventListener("mouseleave", this._onMouseLeave);
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      if (this._acquireTimeout) {
        clearTimeout(this._acquireTimeout);
      }
      if (this._hoverTimeout) {
        clearTimeout(this._hoverTimeout);
      }
      this.removeEventListener("mouseenter", this._onMouseEnter);
      this.removeEventListener("mouseleave", this._onMouseLeave);
    }

    _setSignalLost() {
      if (this.imageEl) {
        this.imageEl.classList.add("grayscale", "brightness-50");
        this.imageEl.classList.remove("saturate-150");
      }
      if (this.glitchContainer) {
        this.glitchContainer.classList.add("is-glitching");
      }
    }

    _acquireSignal() {
      this.signalAcquired = true;
      if (this.imageEl) {
        this.imageEl.classList.remove("grayscale", "brightness-50");
        this.imageEl.classList.add("saturate-150");
      }
      if (this.glitchContainer) {
        this.glitchContainer.classList.remove("is-glitching");
      }
      if (this.staticEl) {
        this.staticEl.style.display = "none";
      }
    }

    _onMouseEnter() {
      if (!this.signalAcquired || !this.glitchContainer) return;

      // Quick 250ms micro-glitch on hover
      this.glitchContainer.classList.add("is-glitching");
      if (this.staticEl) this.staticEl.style.display = "";

      clearTimeout(this._hoverTimeout);
      this._hoverTimeout = setTimeout(() => {
        if (this.glitchContainer) {
          this.glitchContainer.classList.remove("is-glitching");
        }
        if (this.staticEl) this.staticEl.style.display = "none";
      }, 250);
    }

    _onMouseLeave() {
      if (!this.glitchContainer) return;
      this.glitchContainer.classList.remove("is-glitching");
      if (this.staticEl) this.staticEl.style.display = "none";
    }
  }

  customElements.define("glitch-banner", GlitchBanner);
}
